export default "__VITE_ASSET__BtrYYDzZ__"